export const GET_SECTORS_QUERY = `
  query GetSectors($where: sectors_bool_exp = {}) {
    sectors(where: $where, order_by: { created_at: desc }) {
      id
      sector_name
      sector_description
      sector_status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`;

export const GET_SECTOR_BY_ID_QUERY = `
  query GetSectorById($id: Int!) {
    sectors_by_pk(id: $id) {
      id
      sector_name
      sector_description
      sector_status
      company_id
      created_at
      updated_at
      company {
        id
        name
      }
    }
  }
`; 